import styled from '@emotion/styled';
import { device, typography } from '@landsbankinn/ui';
import React from 'react';

interface IProps {
  title: string | null;
  children: React.ReactNode;
}

export const Heading = styled.h2`
  ${typography.h2}
  margin-bottom: 30px;

  @media ${device.tablet} {
    margin-bottom: 60px;
  }
`;

const Wrapper = styled.div``;

export const StaffWithBio = ({ title, children }: IProps) => {
  return (
    <>
      {!!title && <Heading>{title}</Heading>}
      <Wrapper>{children}</Wrapper>
    </>
  );
};
